import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {Nomenclature, NomenclatureSearchParams} from '@accounting/_common/models/nomenclature.models';
import {CategoryListResponse, EntityCategoryTree} from '@common/components-standalone/reference-category-module/category.type';
import {CategoriesTreeState} from '@common/models/entity-state.models';

export const CheckState = createAction(
    '[Nomenclatures] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: Nomenclature[] } }>()
);

export const CheckStateSuccess = createAction(
    '[Nomenclatures] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: Nomenclature[] } }>()
);

export const LoadCategories = createAction(
    '[Nomenclatures] Load Categories',
    props<{ forceUpdate: boolean }>()
);

export const LoadCategoriesSuccess = createAction(
    '[Nomenclatures] Load Categories Success',
    props<{ payload: CategoryListResponse[] }>()
);

export const UpsertCategory = createAction(
    '[Nomenclatures] Upsert Category',
    props<{ payload: CategoryListResponse }>()
);

export const DeleteCategory = createAction(
    '[Nomenclatures] Delete Category',
    props<{ payload: EntityCategoryTree }>()
);

export const SetCategoriesState = createAction(
    '[Nomenclatures] Set Categories State',
    props<{ payload: CategoriesTreeState }>()
);

export const LoadList = createAction(
    '[Nomenclatures] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[Nomenclatures] Load List Success',
    props<{ payload: { items: Nomenclature[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Nomenclatures] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[Nomenclatures] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[Nomenclatures] Set Filter',
    props<{ payload: NomenclatureSearchParams, selectedCategory?: EntityCategoryTree }>()
);

export const SetLoading = createAction(
    '[Nomenclatures] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[Nomenclatures] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[Nomenclatures] Update Item Success',
    props<{ payload: Nomenclature }>()
);

export const DeleteItem = createAction(
    '[Nomenclatures] Delete Item',
    props<{ payload: Nomenclature }>()
);

export const DeleteItemSuccess = createAction(
    '[Nomenclatures] Delete Item Success',
    props<{ payload: Nomenclature }>()
);

export const DeleteItemFailure = createAction(
    '[Nomenclatures] Delete Item Failure',
    props<{ payload: Nomenclature }>()
);

export const SetInitialState = createAction(
    '[Nomenclatures] Set Initial State'
);
